import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { SelectionProvider } from './SelectionContext';
import { AppLayout } from '@/layouts/AppLayout';
import { LoadingScreen } from '@/components/LoadingScreen';
import { LoginPage } from '@/pages/LoginPage';
import { InvitePage } from '@/pages/InvitePage';
import { OverviewPage } from '@/pages/OverviewPage';
import { CompanyPage } from '@/pages/CompanyPage';
import { ProductionPage } from '@/pages/ProductionPage';
import { PnLPage } from '@/pages/PnLPage';
import { ExpensesPage } from '@/pages/ExpensesPage';
import { BusinessUnitsPage } from '@/pages/BusinessUnitsPage';
import { ImportsPage } from '@/pages/ImportsPage';
import { ComparePage } from '@/pages/ComparePage';
import { AlertsPage } from '@/pages/AlertsPage';
import { AuditPage } from '@/pages/AuditPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { OperationalOverviewPage } from '@/pages/operational/OperationalOverviewPage';
import { InventoryPage } from '@/pages/operational/InventoryPage';
import { SuppliersPage } from '@/pages/operational/SuppliersPage';
import { DocumentsPage } from '@/pages/operational/DocumentsPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

function ProtectedRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <SelectionProvider>
      <AppLayout />
    </SelectionProvider>
  );
}

export function AppRouter() {
  const { user, loading } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={loading ? <LoadingScreen /> : user ? <Navigate to="/" replace /> : <LoginPage />}
      />

      {/* Public: the person following an invite link has no account yet. */}
      <Route path="/invite/:token" element={<InvitePage />} />

      <Route element={<ProtectedRoutes />}>
        <Route index element={<OverviewPage />} />
        <Route path="company" element={<CompanyPage />} />
        <Route path="production" element={<ProductionPage />} />
        <Route path="pnl" element={<PnLPage />} />
        <Route path="expenses" element={<ExpensesPage />} />
        <Route path="units" element={<BusinessUnitsPage />} />
        <Route path="imports" element={<ImportsPage />} />
        <Route path="compare" element={<ComparePage />} />
        <Route path="alerts" element={<AlertsPage />} />
        <Route path="audit" element={<AuditPage />} />
        <Route path="settings" element={<SettingsPage />} />

        {/* Операционный контроль — a separate section, sharing the same shell,
            the same session and the same business-unit scope. Each page checks
            its own module grant and renders an explanation rather than a blank
            screen when the person does not hold it; the server refuses the
            underlying endpoints independently. */}
        <Route path="operational" element={<OperationalOverviewPage />} />
        <Route path="operational/inventory" element={<InventoryPage />} />
        <Route path="operational/suppliers" element={<SuppliersPage />} />
        <Route path="operational/documents" element={<DocumentsPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
